var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5831 19.7847L20.3962 12.3476C22.3157 10.5113 22.5954 7.50892 20.782 5.58997C20.3272 5.10639 19.7736 4.71615 19.155 4.44309C18.5365 4.17003 17.8659 4.01989 17.1843 4.00185C16.5027 3.9838 15.8244 4.09823 15.1908 4.33813C14.5573 4.57804 13.9817 4.93839 13.4994 5.39716L12.0333 6.80194L10.7697 5.58997C8.8405 3.76284 5.68633 3.49657 3.67036 5.22271C3.16233 5.65561 2.75235 6.18256 2.46549 6.77137C2.17863 7.36018 2.0209 7.99847 2.00194 8.64726C1.98298 9.29606 2.10319 9.94171 2.35523 10.5448C2.60726 11.1479 2.98583 11.6957 3.4678 12.1548L11.4834 19.7847C11.6298 19.9226 11.8273 20 12.0333 20C12.2392 20 12.4368 19.9226 12.5831 19.7847V19.7847Z",
    stroke: "#131616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export default ForwardRef;